import {
    useState,
    forwardRef,
    useImperativeHandle
} from 'react'
import HideIcon from '../../Icons/HideIcon'
import VisibleIcon from '../../Icons/VisibleIcon'

const NationalIdInput = forwardRef(({ data, title, readOnly }, ref) => {
    const [nationalId, setNationalId] = useState(data || "")
    const [error, setError] = useState(false)
    const [showId, setShowId] = useState(false)
    const [customErrorMsg, setCustomErrorMsg] = useState("")

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const idRegex = /^[A-Za-z0-9]{5,18}$/ // example: 5-18 alphanumeric chars
            const validity = idRegex.test(nationalId)
            setError(!validity)
            setCustomErrorMsg("")
            return {
                isValid: validity,
                value: nationalId
            }
        },
        setError: (err, customMsg) => {
            setError(err)
            setCustomErrorMsg(customMsg || "")
        }
    }))

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700">{title}</label>
            <div className="relative">
                <input
                    type={showId ? "text" : "password"}
                    value={nationalId}
                    onChange={(e) => setNationalId(e.target.value)}
                    disabled={readOnly}
                    maxLength={18}
                    className="block w-full pr-10 pl-3 py-2 rounded-md border border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 text-sm mt-1 mb-2"
                    placeholder="Enter National ID"
                />
                <span
                    onClick={() => setShowId(!showId)}
                    className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-500"
                >
                    {showId ? <HideIcon /> : <VisibleIcon />}
                </span>
            </div>
            {error && (
                <p className="mt-1 text-sm text-red-600">
                    {customErrorMsg || "National ID is invalid"}
                </p>
            )}
        </div>
    )
})

export default NationalIdInput
